import { localeForLanguage, translate, type I18nKey } from "./language.js";
import { useSettingsStore } from "../stores/settings.store.js";

/**
 * Translate OUTSIDE React — for zustand stores, toasts fired from async flows,
 * and any other imperative code that can't call `useI18n()`. Reads the live
 * language straight off the settings store, so it always matches the UI.
 *
 * Components must keep using `useI18n()`: this function doesn't subscribe, so a
 * string captured in render would not re-translate on a language switch.
 */
export function tr(key: I18nKey, vars?: Record<string, string | number | null | undefined>): string {
  return translate(useSettingsStore.getState().language, key, vars);
}

/** The active language's BCP-47 locale, outside React. */
export function trLocale(): string {
  return localeForLanguage(useSettingsStore.getState().language);
}
